import { API_URL } from "./config";
import { fetchUtils } from "react-admin";
import { getBody } from "./authBody";
import { validateResponse } from "./dataProvider";

export const GET_STATS = "stats";

const addDashboardFeature = (requestHandler) => (type, resource, params) => {
  const { fetchJson } = fetchUtils;
  if (resource === "dashboard" && type === GET_STATS) {
    const url = `${API_URL}/console/data`;
    return fetchJson(url, {
      method: "POST",
      body: getBody(),
    })
      .then((response) => validateResponse(response, true))
      .then((response) => ({
        data: response.json,
      }));
  }
  return requestHandler(type, resource, params);
};

export default addDashboardFeature;
